module.exports = __webpack_public_path__ + "img/gb13871-92_35x55x8.prt.c2d99f21.jpg";